<template>
  <base-icon
    icon="users"
    :action="goTo"
    title="ユーザー管理"
  />
</template>

<script>
import BaseIcon from './Base'

export default {
  components: {
    BaseIcon
  },

  methods: {
    goTo () {
      this.$router.push({ name: 'users' })
    }
  }
}
</script>
